/* RP Red theme — gallery + variant picker. No dependencies. */
(function () {
  // ---------- scroll reveal (all pages) ----------
  // Baked info pages (analytics/crewlogger, home sections, etc.) carry the
  // `.reveal{opacity:0}` CSS from the concept but not the concept's inline
  // observer. Without this, every `.reveal` block stays invisible. Runs before
  // the product-form early return below so it works on non-product pages too.
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { revealIO.observe(el); });
    }
  }

  // ---------- product gallery ----------
  var main = document.getElementById('mainImg');
  if (main) {
    var thumbs = document.querySelectorAll('.thumbs button');
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        main.removeAttribute('srcset');
        main.src = b.dataset.src;
      });
    });
    // preload full-size gallery images so thumb clicks swap instantly
    var preload = function () {
      thumbs.forEach(function (b) { new Image().src = b.dataset.src; });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(preload); else setTimeout(preload, 800);
  }

  // ---------- variant picker ----------
  var jsonEl = document.querySelector('[data-product-json]');
  var form = document.getElementById('product-form');
  if (!jsonEl || !form) return;

  var variants;
  try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

  var groups = document.querySelectorAll('[data-option-index]');
  var idInput = form.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-price]');
  var btn = form.querySelector('[data-add-btn]');
  var btnPrice = form.querySelector('[data-btn-price]');

  function selectedOptions() {
    var opts = [];
    groups.forEach(function (g) {
      var on = g.querySelector('.on');
      opts[parseInt(g.dataset.optionIndex, 10)] = on ? on.dataset.value : null;
    });
    return opts;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function update() {
    var opts = selectedOptions();
    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
    });
    if (!match) return;
    idInput.value = match.id;
    var cur = document.querySelector('[data-price] .cur');
    if (priceEl) priceEl.innerHTML = money(match.price) + (cur ? ' ' + cur.outerHTML : '');
    if (btn) {
      if (match.available) {
        btn.disabled = false;
        btn.style.opacity = '';
        if (btnPrice) btnPrice.textContent = money(match.price);
      } else {
        btn.disabled = true;
        btn.style.opacity = '.55';
      }
    }
  }

  groups.forEach(function (g) {
    var idx = g.dataset.optionIndex;
    g.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        g.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        var lbl = document.querySelector('[data-optlabel="' + idx + '"]');
        if (lbl) lbl.textContent = b.dataset.label || b.dataset.value;
        update();
      });
    });
  });
})();
